
export const refundPolicies = [
  {
    id: 1,
    title: '투어 출발 72시간 이전 취소',
    percentage: 100,
    description: '투어 출발일 기준 72시간(3일) 이전에 취소를 요청하시면 결제 금액의 100%를 전액 환불해 드립니다.',
    highlight: true,
  },
  {
    id: 2,
    title: '투어 출발 48~72시간 전 취소',
    percentage: 70,
    description: '투어 출발일 기준 48시간~72시간 사이에 취소를 요청하시면 결제 금액의 70%를 환불해 드립니다.',
    highlight: false,
  },
  {
    id: 3,
    title: '투어 출발 24~48시간 전 취소',
    percentage: 50,
    description: '투어 출발일 기준 24시간~48시간 사이에 취소를 요청하시면 결제 금액의 50%를 환불해 드립니다.',
    highlight: false,
  },
  {
    id: 4,
    title: '투어 출발 24시간 이내 취소',
    percentage: 0,
    description: '투어 출발일 기준 24시간 이내에 취소하시거나 사전 연락 없이 불참(No-show)하신 경우 환불이 불가합니다.',
    highlight: false,
  },
];

export const refundProcess = [
  {
    step: 1,
    title: '환불 신청',
    description: '카카오톡 또는 이메일로 환불 요청을 보내주세요.',
    icon: 'ri-mail-send-line',
    duration: '즉시',
  },
  {
    step: 2,
    title: '접수 확인',
    description: '담당자가 환불 요청을 확인하고 안내 메시지를 보내드립니다.',
    icon: 'ri-checkbox-circle-line',
    duration: '24시간 이내',
  },
  {
    step: 3,
    title: '환불 승인',
    description: '취소 시점에 따른 환불 비율을 적용하여 승인 처리합니다.',
    icon: 'ri-shield-check-line',
    duration: '1~2 영업일',
  },
  {
    step: 4,
    title: '환불 완료',
    description: '결제 수단에 따라 환불 금액이 입금됩니다.',
    icon: 'ri-money-dollar-circle-line',
    duration: '3~5 영업일',
  },
];

export const specialCases = [
  {
    id: 1,
    icon: 'ri-thunderstorms-line',
    title: '기상 악화로 인한 취소',
    description: '태풍, 폭풍 등 기상 악화로 투어가 불가능한 경우 전액 환불 또는 무료 날짜 변경이 가능합니다. 가벼운 비는 투어 진행에 영향을 주지 않습니다.',
    color: '#E0F7FA',
    iconColor: '#00BCD4',
  },
  {
    id: 2,
    icon: 'ri-heart-pulse-line',
    title: '건강 문제 / 의료 사유',
    description: '의사 진단서 또는 의료 증빙 서류를 제출하시면 취소 시점에 관계없이 전액 환불 또는 날짜 변경이 가능합니다.',
    color: '#FFF3E0',
    iconColor: '#FF9800',
  },
  {
    id: 3,
    icon: 'ri-flight-takeoff-line',
    title: '항공편 지연 / 취소',
    description: '항공사 사유로 인한 항공편 지연 또는 취소 시, 항공사 확인서를 제출하시면 전액 환불 또는 무료 일정 변경이 가능합니다.',
    color: '#F3E5F5',
    iconColor: '#9C27B0',
  },
  {
    id: 4,
    icon: 'ri-group-line',
    title: '최소 인원 미달',
    description: '조인 투어의 경우 최소 출발 인원이 미달되어 투어가 취소될 경우, 전액 환불 또는 다른 날짜로 무료 변경해 드립니다.',
    color: '#E8F5E9',
    iconColor: '#4CAF50',
  },
];

export const refundMethods = [
  {
    method: '카카오페이',
    duration: '즉시 ~ 3영업일',
    icon: 'ri-kakao-talk-fill',
  },
  {
    method: '계좌이체 (한국 은행)',
    duration: '1~2 영업일',
    icon: 'ri-bank-line',
  },
  {
    method: '현지 페소 현금',
    duration: '현장 즉시 환불',
    icon: 'ri-money-dollar-box-line',
  },
];

export const importantNotes = [
  '환불 금액은 결제 수단에 따라 처리 기간이 다를 수 있습니다.',
  '부분 참여 후 중도 이탈 시에는 환불이 불가합니다.',
  '프로모션 또는 할인 적용 상품의 경우 별도의 환불 규정이 적용될 수 있습니다.',
  '단체 예약(10인 이상)의 경우 별도 협의가 필요합니다.',
  '환불 신청은 예약자 본인만 가능하며, 본인 확인 절차가 필요합니다.',
  '날짜 변경은 투어 출발 48시간 전까지 1회에 한해 무료로 가능합니다.',
];
